import { Accordion } from "@mantine/core";
import type { ReactNode } from "react";

interface ParentProps {
  children?: ReactNode;
}

interface AccordionItemProps {
  children?: ReactNode;
  label?: string;
  title?: string;
  value?: string;
}

/**
 * MarkdocAccordion renders the {% accordion %} tag as a Mantine `Accordion` that
 * allows multiple open sections.
 */
export const MarkdocAccordion = ({ children }: ParentProps) => (
  <Accordion multiple my="md" variant="separated">
    {children}
  </Accordion>
);

/**
 * AccordionItem renders one {% accordion-item %} as a labelled, collapsible
 * Mantine `Accordion.Item`. `label` or `title` sets the control text, while the
 * parent {% accordion %} transform supplies the unique `value` the item is keyed
 * by — so two items sharing a label still toggle independently.
 */
export const AccordionItem = ({ children, label, title, value }: AccordionItemProps) => {
  const control = label ?? title ?? "";

  return (
    <Accordion.Item value={value ?? control}>
      <Accordion.Control>{control}</Accordion.Control>
      <Accordion.Panel>{children}</Accordion.Panel>
    </Accordion.Item>
  );
};
